import { Wrapper } from './Styled'

export default function Unknown() {
  return <Wrapper>Unknown</Wrapper>
}
